import { Controller } from '@hotwired/stimulus'
import axios from '../lib/axios/defaultInstance'

/**
 * QaApiController
 *
 * Generic POST handler for QA tools modal forms. Attach to a <form> with
 * `data-controller="qa-api"`; the controller serializes every form field
 * via FormData, POSTs to `form.action`, and writes the response message to
 * the `feedback` target. New QA modules don't need new JS — just add inputs
 * to a form pointing at any QA endpoint.
 */
export default class extends Controller {
  static targets = ['feedback']

  async post(event) {
    const form = this.element
    const data = Object.fromEntries(new FormData(form))
    const button = event.currentTarget

    button.disabled = true
    if (this.hasFeedbackTarget) this.feedbackTarget.textContent = ''

    try {
      const { data: response } = await axios.post(form.action, data)
      if (this.hasFeedbackTarget) {
        this.feedbackTarget.textContent = response.message ?? '✓ Done'
      }
    } catch (err) {
      if (this.hasFeedbackTarget) {
        this.feedbackTarget.textContent = `✗ ${err.response?.data?.error ?? 'Error'}`
      }
    } finally {
      button.disabled = false
    }
  }
}
